import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { makeCategory as makeApiCategory } from '../../../api-calls/categories'
import { deleteCategory as deleteApiCategory } from '../../../api-calls/categories'
import DropDownCategoryLeagues from '../../layoutComponents/DropDownCategoryLeagues'
import NavViews from '../../../stores/NavViews';
import { Popconfirm, message, Icon } from 'antd'

@observer(["ViewStore", "UserStore", "CategoriesStore", "AuthStore", "CustomRouter"])
class ManageCategories extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
            picUrls: [{ url: '' }],
            cleanPicUrls: {},
            categoryTitle: '',
            categoryLogoUrl: '',
            categoryList: {}
        };

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleLogoUrlChange = this.handleLogoUrlChange.bind(this);
        this.handlePicUrlChange = this.handlePicUrlChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAddPicUrl = this.handleAddPicUrl.bind(this);
        this.handleRemovePicUrl = this.handleRemovePicUrl.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }

    async componentWillMount() {
        const { CategoriesStore } = this.props;

        CategoriesStore.queryCategories();
    }

    handlePicUrlChange = (idx) => (e) => {
        const newPicUrls = this.state.picUrls.map((picUrl, sidx) => {
            if (idx !== sidx) return picUrl;
            return { ...picUrl, url: e.target.value };
        });

        this.setState({ picUrls: newPicUrls });
    }

    handleSubmit() {
        const { url, picUrls } = this.state;
        const { CategoriesStore } = this.props;
        const { AuthStore } = this.props;
        const authToken = AuthStore.userAuth.auth.accessToken;

        let title = this.state.categoryTitle;
        let logoUrl = this.state.categoryLogoUrl;
        let cleanUrlList = []
        const results = this.state.picUrls.map((PicUrl) => { PicUrl.url !== "" ? cleanUrlList.push(PicUrl.url) : null });


        Promise.all(results).then(() => makeApiCategory(
            authToken,
            title,
            logoUrl,
            cleanUrlList,
        ).then(() => {
            CategoriesStore.queryCategories().then(() => {
                message.success('Category Added!')
            }).then(() => {
                this.setState({ picUrls: [{ url: '' }], categoryTitle: '', categoryLogoUrl: '' })
                cleanUrlList = []
            })
        }));
    }

    handleAddPicUrl = () => {
        this.setState({
            picUrls: this.state.picUrls.concat([{ url: '' }])
        });
    }

    handleRemovePicUrl = (idx) => () => {
        this.setState({
            picUrls: this.state.picUrls.filter((s, sidx) => idx !== sidx)
        });
    }

    handleTitleChange = (e) => {
        this.setState({ categoryTitle: e.target.value });
    }

    handleLogoUrlChange = (e) => {
        this.setState({ categoryLogoUrl: e.target.value });
    }

    onClickDelete(categoryId) {
        const { AuthStore, CategoriesStore } = this.props;
        const authToken = AuthStore.userAuth.auth.accessToken;
        
        return deleteApiCategory(
            authToken,
            categoryId
        ).then(() => {
            message.success('Category Deleted!')
        }).then(() => {
            CategoriesStore.queryCategories();
        });
    }

    renderCategoryDeleteList() {
        const { CategoriesStore, CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;
        const { router: { params } } = CustomRouter;

        let categoryList = []
        let categories = Array.from(CategoriesStore.categories.values());

        for (let category of categories) {
            categoryList.push(
                <div className="admin-delete-table" key={category._id}>
                    <div className="admin-delete-table-column-title-logo">
                    <img src={require(`../../../assets/img/categories/${category.title.toLowerCase()}.png`)} width="20"/>
                        <span onClick={() => goTo(NavViews.categories, { categoryId: category._id }, CustomRouter)}>{category.title}</span>
                        <DropDownCategoryLeagues categoryId={category._id} />
                    </div>
                    <div>
                        <Popconfirm title={"Sure you want to delete " + category.title + "?"} onConfirm={() => { this.onClickDelete(category._id) }} okText="Yes" cancelText="No">
                            <button className="custom-btn-danger"><Icon type="delete" /></button>
                        </Popconfirm>

                    </div>
                </div>
            )
        }
        return categoryList;
    }

    render() {

        return (
            <div className="admin-wrap">
                <h2>Add a Category</h2>
                <div className="admin-form">
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Title: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="Category Title"
                            value={this.state.categoryTitle}
                            onChange={this.handleTitleChange}
                        />
                    </div>
                    {/* <div className="admin-form-field">
                        <div className="admin-form-field-title">Logo URL: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="Category Logo URL"
                            value={this.state.categoryLogoUrl}
                            onChange={this.handleLogoUrlChange}
                        />
                    </div> */}
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Background Picture Urls: </div>
                        {this.state.picUrls.map((PicUrl, idx) => (
                            <div className="PicUrl" key={idx}>
                                <input
                                    type="text"
                                    className="custom-input"
                                    style={{ width: '60%' }}
                                    placeholder={`Background Pic URL #${idx + 1}`}
                                    value={PicUrl.url}
                                    onChange={this.handlePicUrlChange(idx)}
                                />
                                <button className="custom-btn-primary" type="button" onClick={this.handleRemovePicUrl(idx)}>-</button>
                                {this.state.picUrls.length == (idx + 1) ?
                                    <button className="custom-btn-primary" type="button" onClick={this.handleAddPicUrl}>Add Field</button>
                                    :
                                    null
                                }
                            </div>
                        ))}
                    </div>
                </div>
                <div style={{ marginTop: '15px' }}>
                    <button onClick={this.handleSubmit} className="custom-btn-primary">Submit</button>
                </div>
                <br /><br /><br /><hr /><br /><br /><h1>Delete Categories</h1><br />
                <div>                    
                    {this.renderCategoryDeleteList()}
                </div>
            </div>
        );
    }
}

export default ManageCategories;


// WEBPACK FOOTER //
// ./src/components/appComponents/admin/ManageCategories.js